import { useMutation, useQuery } from "@tanstack/react-query";
import {
  setAccessToken,
  setRefreshToken,
  clearAuthStorage,
  setUser,
} from "../../utils/storage";
import axiosPublic from "../axiosPublic";
import { useNavigate } from "react-router-dom";
import axiosPrivate from "../axiosPrivate";

// Login
export const useLogin = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async (credentials) => {
      const res = await axiosPublic.post("login", credentials);
      return res.data;
    },
    onSuccess: (data) => {
      setAccessToken(data.data.token);
      console.log(data.data.token, "The main access Token");

      setUser(data.data.profile);

      navigate("/dashboard");
    },
    onError: (error) => {
      console.error("Login failed:", error?.response?.data || error.message);

      return error;
    },
  });
};
// Login
export const useVerifyBvn = (bvn) => {
  return useQuery({
    queryKey: ["verifyBvn", bvn],
    queryFn: async () => {
      const res = await axiosPublic.get(`verify/bvn/${bvn}`);
      return res.data;
    },
    enabled: !!bvn,
    staleTime: 1000 * 60 * 5,
  });
};

// Register
export const useRegister = () =>
  useMutation({
    mutationFn: async (newUser) => {
      const res = await axiosPublic.post("register", newUser);
      return res.data;
    },
    onSuccess: (data) => {
      setAccessToken(data.accessToken);
      setRefreshToken(data.refreshToken);
    },
  });

// Logout
export const useLogout = () =>
  useMutation({
    mutationFn: async () => {
      await axiosPublic.post("auth/logout");
    },
    onSuccess: () => {
      clearAuthStorage();
    },
  });
